module.exports = __webpack_public_path__ + "img/vidio.67640e0f.svg";